export const GET_ADDITIONAL_FIELDS = "GET_ADDITIONAL_FIELDS";
export const CREATE_ADDITIONAL_FIELD = "CREATE_ADDITIONAL_FIELD";
export const CREATE_ADDITIONAL_FIELDS_SUCCESS = "GET_ADDITIONAL_FIELDS_SUCCESS";
export const SET_ADDITIONAL_FIELDS = "SET_ADDITIONAL_FIELDS";
export const SET_ADDITIONAL_FIELD = "SET_ADDITIONAL_FIELD";
export const SET_ADDITIONAL_FIELDS_STATUS = "SET_ADDITIONAL_FIELDS_STATUS";
export const RESET_ADDITIONAL_FIELDS = "RESET_ADDITIONAL_FIELDS";
export const ACTIVATE_ADDITIONAL_FIELD = "ACTIVATE_ADDITIONAL_FIELD";
export const ACTIVATE_ADDITIONAL_FIELD_SUCCESS = "ACTIVATE_ADDITIONAL_FIELD_SUCCESS";
export const GET_ADDITIONAL_FIELD = "GET_ADDITIONAL_FIELD";
export const GET_ADDITIONAL_FIELD_SUCCESS = "GET_ADDITIONAL_FIELD_SUCCESS";
export const EDIT_ADDITIONAL_FIELD = "EDIT_ADDITIONAL_FIELD";
export const EDIT_ADDITIONAL_FIELD_SUCCESS = "EDIT_ADDITIONAL_FIELD_SUCCESS";
export const API_ERROR = "API_ERROR";
export const RESET_ERROR = "RESET_ERROR";